export default __webpack_public_path__ + "static/media/about1.6e50bbf9.png";